export default __webpack_public_path__ + "8b88b4ee47d545cc0fe1dd19f22ec013.woff";